import { Controller } from '@hotwired/stimulus';

export default class ProgramsFilterController extends Controller {
  static targets = ['location', 'search', 'filter'];

  static values = {
    defaultStagename: String,
    pageParam: String,
    orderParam: String,
    directionParam: String,
  }

  clearFilters (event) {
    const { filter } = event.target.dataset;
    const { src } = this.searchTarget;
    const url = new URL(src);

    this.filterTargets.filter(item => item.name === filter).forEach((item) => {
      item.checked = false;
    });

    url.searchParams.delete(this.pageParamValue);
    url.searchParams.delete(filter);
    this.updateDownloadCSVButton(url.searchParams);
    this.searchTarget.src = url;
  }

  clearAllFilters () {
    const { src } = this.searchTarget;
    const url = new URL(src);
    const params = Array.from(url.searchParams.keys());

    params.filter(item => item !== this.orderParamValue && item !== this.directionParamValue)
      .forEach((param) => {
        if (param === 'pg_status') {
          return null;
        }
        if (!param.startsWith('enrollments[stagename]')) {
          return url.searchParams.delete(param);
        }
        return null;
      });

    this.filterTargets.forEach((item) => { item.checked = false; });
    this.updateDownloadCSVButton(url.searchParams);
    this.searchTarget.src = url;
  }

  filterSelectChange (event) {
    const type = event.target.name;
    const { value } = event.target.dataset;
    const url = this.searchTarget.src
      || (this.hasLocationTarget && this.locationTarget.src)
      || this.getDefaultStagenameParameter();

    if (event.target.checked) {
      this.addFilterParam(new URL(url), type, value);
    } else {
      this.removeFilterParam(new URL(url), type, value);
    }
  }

  pillSelectChange (event) {
    const filter = this.filterTargets.find(item => item.id === event.target.dataset.filterId);

    if (filter) filter.click();
  }

  elementsPerPageChange (event) {
    const { value } = event.target;
    const url = this.searchTarget.src
      || (this.hasLocationTarget && this.locationTarget.src)
      || this.getDefaultStagenameParameter();

    this.updateElementsPerPage(new URL(url), value);
  }

  updateElementsPerPage (url, value) {
    const { searchParams } = url;

    searchParams.set('enrollments[per_page]', value);
    this.updateDownloadCSVButton(searchParams);
    this.searchTarget.src = url;
    this.updatePath(this.searchTarget.src);
  }

  /* eslint-disable-next-line class-methods-use-this */
  updateDownloadCSVButton (searchParams) {
    const downloadCsv = document.getElementById('downloadCsv');
    if (downloadCsv) {
      let downloadCsvUrl = new URL(downloadCsv.href);
      downloadCsvUrl.search = searchParams;
      downloadCsvUrl = downloadCsvUrl.toString();
      downloadCsv.href = downloadCsvUrl;
    }
  }

  getDefaultStagenameParameter () {
    if (this.defaultStagenameValue) {
      return `${window.location.href}?enrollments[stagename]=${this.defaultStagenameValue}`;
    }

    return window.location.href;
  }

  addFilterParam (url, type, value) {
    const { searchParams } = url;
    searchParams.delete(this.pageParamValue);

    if (searchParams.has(type)) {
      searchParams.set(type, `${searchParams.get(type)},${value}`);
    } else {
      searchParams.set(type, value);
    }
    this.updateDownloadCSVButton(searchParams);
    this.searchTarget.src = url;
    this.updatePath(this.searchTarget.src);
  }

  removeFilterParam (url, type, value) {
    const { searchParams } = url;
    const values = searchParams.get(type).split(',');

    searchParams.delete(this.pageParamValue);
    values.splice(values.indexOf(value), 1);

    if (values.length === 0) {
      searchParams.delete(type);
    } else {
      searchParams.set(type, values.join(','));
    }
    this.updateDownloadCSVButton(searchParams);
    this.searchTarget.src = url;
    this.updatePath(this.searchTarget.src);
  }

  // eslint-disable-next-line class-methods-use-this
  updatePath (src) {
    const pathnameIndex = window.location.href.indexOf('?') === -1 ? window.location.href.length : window.location.href.indexOf('?');
    const srcIndex = src.indexOf('?');
    const srcParams = srcIndex !== -1 ? src.substring(srcIndex, src.length) : '';

    window.history.replaceState(
      null, null,
      window.location.href.substring(0, pathnameIndex) + srcParams,
    );
  }
}
